import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

const backendOptions = {
  loadPath: location.origin + '/vocabs/{{lng}}'
};

i18n
  .use(detector)
  .use(backend)
  .use(initReactI18next)
  .init({
    react: {
      useSuspense: false,
      wait: false,
    },
    initImmediate: false,
    lng: window?.forgeVariables?.currentSite?.culture ? window.forgeVariables?.currentSite.culture : "en-US",
    fallbackLng: "en-US",
    interpolation: {
      escapeValue: false
    },
    debug: true,
    backend: backendOptions,
    keySeparator: true,

  });

export default i18n;
